import React from "react";
import {useSelector, useDispatch} from "react-redux";
import variables from "../variables";
import constants from "../constants";
import people, {currentPlayer} from "../people/people";
import {getTimeString, getDateString, notify} from "./functions";
import {setDialogContent} from "../../app/projectSlice";
import {jumpTo} from "../../Utils";
import places from "../places/places";
import Image from "../../features/Image";
import images from "../images";
import Name from "../../features/Name";
import missions from "../missions";
import conditions from "../conditions";

const StoryContent = (props) => {
    const dispatch = useDispatch();
    const project = useSelector(state => state.project);

    const onImageClick = e => dispatch(setDialogContent("wifeStat"));

    const onPlayAsPlayerClick = () => {
        if (!variables.game.nowIsStory) {
            people.player.where = places[variables.player.schedule[variables.game.time[1]][variables.game.time[0]]].id;
            currentPlayer.set(people.player);
            notify(<span>Current Player was set to&#160;<Name who={people.player}/></span>);
            jumpTo("game.playAsNow");
        } else {
            notify("You can change player only when it's not Story-tell time")
        }
    };

    const onPlayAsWifeClick = () => {
        currentPlayer.set(people.wife);
        dispatch(setDialogContent(null));
        notify(<span>Current Player was set to&#160;<Name who={people.wife}/></span>);
        jumpTo("game.playAsNow");
    };

    const getDay02variables = () => {
        return variables.game.day02.started ? <div>
            <span>
                <div style={{color: "red"}} className="story-debt">DEBT: {people.player.debt}$</div>
                Rent: {constants.homes[variables.game.home].payment}$ Payed:&#160;
                {
                    variables.game.rentPayed ?
                        <span className="rent-paid" style={{color: "green"}}>YES</span> :
                        <span className="rent-not-paid" style={{color: "red"}}>NO</span>
                }
            </span>
            <div style={{color: "grey"}}>Payment every {constants.player.rentDay}st day of Month.</div>
        </div> : <div/>
    };

    return (
        <div>
            { variables.game.wasStarted ?
                <div>
                    <h2 className="story-date">{getDateString()}</h2>
                    <h3 className="story-time">{getTimeString()}</h3>
                    <span className="story-money">Money: {people.player.money}$</span>
                    {getDay02variables()}
                    <div className="story-relations" style={{color: "blue"}}>
                        <Name who={people.wife} noStyle/> relations: {people.wife.relations}/100
                    </div>
                    {
                        !currentPlayer.isWife() &&
                        <div>
                            <h3 className="story-appearance"><Name who={people.wife} noStyle/>'s appearance</h3>
                            <Image style={{minWidth: 0}} src={people.wife.occupations.get().getImage()} onClick={onImageClick}/>
                        </div>
                    }
                    {
                        currentPlayer.isWife() &&
                        <div>
                            <h3>{people.player.getName()} is in {places[variables.player.schedule[variables.game.time[1]][variables.game.time[0]]].name} now.</h3>
                        </div>
                    }
                    <div>{
                        currentPlayer.isWife() &&
                        <button
                            className="play-as-player-btn"
                            style={{backgroundColor: "rgba(210,210,210,0.5)"}}
                            onClick={onPlayAsPlayerClick}
                        >Play as&#160;<Name who={people.player}/>
                        </button>
                    }</div>
                    <div>
                        {missions.initCorruption_01.tasks.tellWifeAboutJobOps_01.finished && currentPlayer.isPlayer() &&
                        <button
                            className="play-as-player-btn"
                            onClick={onPlayAsWifeClick}
                            style={{backgroundColor: "rgba(210,210,210,0.5)"}}
                            disabled={conditions.switchToWifeIsDisabled()}
                        >
                            Play as&#160;<Name who={people.wife}/>
                        </button>
                        }
                    </div>
                </div> : <div><Image style={{marginTop: "50px", cursor: "default"}} src={images.game.mainImage}/></div>
            }
        </div>
    );
};

export default StoryContent;